export interface UsersAppWebComponentSchema {
  // all the data needed for rendering
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnIndexes {
  COMPANY = 0,
  USERNAME = 1,
  RISK_SCORE = 2,
  RISKS = 3,
  USER_TYPE = 4,
  USER_DEVICES = 5,
  DEPARTMENT = 6,
  STATUS = 7,
  STATE = 8,
  WATCHLIST = 9,
  SELECT = 10,
  REGION = 11,
  RESOURCE_ID = 12,
  OPERATING_SYSTEMS = 13,
}

export enum ColumnKeys {
  COMPANY = 'companyId',
  USERNAME = 'username',
  RISK_SCORE = 'scoreBreakdown.finalScore',
  RISKS = 'devices.items.indicators.indicatorId',
  USER_TYPE = 'userType',
  USER_DEVICES = 'devices.items.endpointId',
  DEPARTMENT = 'department',
  STATUS = 'status',
  STATE = 'state',
  WATCHLIST = 'watchlist',
  SELECT = 'select',
  REGION = 'region',
  RESOURCE_ID = 'resourceId',
  OPERATING_SYSTEMS = 'operatingSystems',
}

export enum UserType {
  LOCAL = 1,
  AD = 2,
  ACTIVE_DIRECTORY_USER = 1000,
  IAM_ROLE = 1001,
  IAM_USER = 1002,
  IAM_USER_GROUP_ROLE = 1003,
  IAM_GROUP = 1004,
  ROOT_USER = 1005,
  IAM_SERVICE_ACCOUNT = 1006,
}
